import {
  type MeasurementEvent,
  type PushMeasurementOptions,
  faro,
} from '@grafana/faro-web-sdk'

/**
 * Push a custom Faro measurement (e.g. a call duration or a business metric).
 *
 * No-op server-side or before Faro has finished initialising.
 *
 * @example
 * pushMeasurement(
 *   { type: 'my_feature', values: { duration_ms: 120 } },
 *   { context: { outcome: 'completed' } },
 * )
 */
export function pushMeasurement(
  payload: Omit<MeasurementEvent, 'timestamp'> &
    Partial<Pick<MeasurementEvent, 'timestamp'>>,
  options?: PushMeasurementOptions,
) {
  if (typeof window === 'undefined') return

  faro?.api?.pushMeasurement(payload, options)
}
